import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const PDISummaryViewModule = new Module({
  id: 'REPORT-PDI-SUMMARY:VIEW:*',
  name: 'PDI Summary Report',
  label: 'PDI Summary',
  path: 'pdi-summary',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/PDISummary/View'))
  ),
  actions: {
    viewDetails: {
      id: 'REPORT-PDI-SUMMARY:VIEW:DETAILS',
      name: 'view-details',
      label: 'View Details'
    }
  }
});

export const PDIDetailsModule = new Module({
  id: 'REPORT-PDI-SUMMARY:VIEW:DETAILS-PAGE',
  name: 'PDI Details Report',
  label: 'PDI Details',
  path: 'pdi-summary/pdi-details',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/PDISummary/Details'))
  )
});

const PDISummaryModules = [PDISummaryViewModule, PDIDetailsModule];

export default new ModuleBundle('PDISummary', PDISummaryModules);
